import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, formPropTypes, Field } from 'redux-form';
import {
  Row,
  Col,
  FormGroup,
  Button,
} from 'react-bootstrap';

import PayPeriodFilter from '../../fields/PayPeriodFilter';
import { createRenderer } from '../../reduxForm/utils';
import { setPayPeriodThunk } from '../actions';
import { getPayPeriodId } from '../selectors';

const FORM_NAME = 'guaranteedHoursForm';

const propTypes = exact({
  setPayPeriodAction: PropTypes.func.isRequired,
  payPeriodId: PropTypes.number,
  initialValues: PropTypes.object,

  validate: PropTypes.func.isRequired,
  ...formPropTypes,
});

const validate = (values) => {
  const errors = [];
  const { payPeriod } = values;

  if (!payPeriod) {
    errors.payPeriod = 'Required';
  }
  return errors;
};

const RenderPayPeriod = createRenderer((input, label) => {
  return (
    <PayPeriodFilter {...input} />
  );
});

const FilterGuaranteedHoursPanel = (props) => {
  const {
    handleSubmit,
    submitting,
    invalid,
    pristine,
  } = props;

  const formSubmit = (values) => {
    const { setPayPeriodAction } = props;
    setPayPeriodAction(values.payPeriod);
  };

  return (
    <form onSubmit={handleSubmit(formSubmit)}>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Field
              name="payPeriod"
              type="select"
              label="Pay Period"
              format={null}
              component={RenderPayPeriod}
            />
          </FormGroup>
        </Col>
      </Row>
      <Button
        bsStyle="primary"
        type="submit"
        disabled={(submitting || pristine || invalid)}
      >
        Submit
      </Button>
    </form>
  );
};


FilterGuaranteedHoursPanel.propTypes = propTypes;
FilterGuaranteedHoursPanel.defaultProps = {
  initialValues: {},
};

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
});

const mapStateToProps = (state) => {
  return {
    payPeriodId: getPayPeriodId(state),
  };
};

const mapDispatchToProps = {
  setPayPeriodAction: setPayPeriodThunk,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withForm,
);


export default enhance(FilterGuaranteedHoursPanel);
